import {
  BellOutlined,
  QuestionCircleOutlined,
  PartitionOutlined,
  LogoutOutlined,
  CalendarOutlined,
  CalculatorOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
  HomeOutlined,
  SafetyCertificateOutlined,
  AimOutlined,
  MessageOutlined,
  RiseOutlined,
  TrophyOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  WalletOutlined,
  SolutionOutlined,
  BankOutlined,
} from '@ant-design/icons';
import { ShellChrome } from './ShellChrome';
import { navItem } from './navItem';
import { useCollaborationNav } from './useCollaborationNav';

/**
 * Employee self-service (PRD §5.7).
 *
 * Deliberately short. An employee opens this to do one of four things — mark
 * attendance, book leave, look at their own record, or exercise a privacy
 * right — and a longer menu would only make those four harder to find.
 */
export function EmployeeShell() {
  const collaboration = useCollaborationNav('/ess');
  return (
    <ShellChrome
      shell="ess"
      navItems={[
        navItem('/ess', 'Home', <HomeOutlined />),
        ...collaboration,
        navItem('/ess/attendance', 'My attendance', <ClockCircleOutlined />),
        navItem('/ess/leave', 'My leave', <CalendarOutlined />),
        navItem('/ess/joining', 'Joining', <UsergroupAddOutlined />),
        navItem('/ess/letters', 'My letters', <FileTextOutlined />),
        // Above the tax declaration on purpose: far more people come here to
        // find last month's payslip than to change their regime.
        navItem('/ess/pay', 'My pay', <WalletOutlined />),
        navItem('/ess/claims', 'My expenses', <SolutionOutlined />),
        navItem('/ess/bank', 'Where I am paid', <BankOutlined />),
        navItem('/ess/tax', 'Tax declaration', <CalculatorOutlined />),
        navItem('/ess/performance', 'My review', <TrophyOutlined />),
        navItem('/ess/goals', 'My goals', <AimOutlined />),
        navItem('/ess/feedback-requests', 'Feedback asked of me', <MessageOutlined />),
        navItem('/ess/improvement-plans', 'My plan', <RiseOutlined />),
        navItem('/ess/profile', 'My profile', <UserOutlined />),
        navItem('/ess/org-chart', 'Org chart', <PartitionOutlined />),
        navItem('/ess/resignation', 'Resigning', <LogoutOutlined />),
        // The DPDP access and withdrawal rights (03 §5) live here rather than
        // buried in a profile tab: a right that is hard to find is a right that
        // is hard to exercise.
        navItem('/ess/privacy', 'My privacy', <SafetyCertificateOutlined />),
        navItem('/ess/notifications', 'Notifications', <BellOutlined />),
        navItem('/ess/help', 'Get help', <QuestionCircleOutlined />),
      ]}
    />
  );
}
